// Self-service subscription view + switch (docs/DECISIONS.md, "Default
// Trial Plan on signup + self-service subscription + registration consent"
// plan file), mirroring practiceContent.js's apiFetch/origin-constant style.

import { apiFetch, PRACTICE_SERVICE_ORIGIN } from './api';

// Returns { current: {...} | null, free_plans: [...], other_plans: [...] }
// or null on any failure - matches this file's own submitProfile-style
// "return the raw response for switchMySubscription, but fail safe for a
// read" split seen elsewhere in this service layer.
export async function getMySubscription() {
  const response = await apiFetch('/api/practice/subscription', {}, PRACTICE_SERVICE_ORIGIN);
  if (!response.ok) return null;
  return response.json();
}

// Returns the raw fetch Response - callers inspect .ok/.status and read
// body.detail themselves (matches studentProfile.js's submitProfile
// convention), since a rejected switch (plan_requires_payment,
// plan_not_found_or_inactive) needs its real backend message surfaced, not
// swallowed into a generic failure.
export async function switchMySubscription(planId) {
  return apiFetch(
    '/api/practice/subscription',
    { method: 'PUT', body: JSON.stringify({ plan_id: planId }) },
    PRACTICE_SERVICE_ORIGIN
  );
}
